const func = $target => {
    var $modal = $target.find('#deleteAddressModal');
    var $modalInput = $modal.find('input#deleteAddressId');
    $($modal).on('show.bs.modal', function(e) {
        $($modalInput).val($(e.relatedTarget).data('address-id'));
    });
    $($modal).on('hide.bs.modal', function(e) {
        $($modalInput).val('');
    });
    var $contactCheck = $target.find('#contactDetailsCheck');
    if (($($contactCheck).length) && ($($contactCheck).attr('checked') == false)) {
        $($target.find('input#firstName')).val('');
        $($target.find('input#lastName')).val('');
        $($target.find('input#phone')).val('');
    }
};

export default func;